import {
    CreationToolInjectedProps,
    SearchAndSelect,
    SearchAndSelectProps,
} from "@kaltura/mediaspace-shared-search-and-select";
import { Button, Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { styled } from "@mui/material";
import { Box, FeatureContainer, systemWidth } from "@kaltura/mediaspace-shared-styled";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config/useConfig";
import { useState } from "react";
import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { CreationToolWrapper } from "./creation-tools/creation-tool-wrapper/CreationToolWrapper";

export interface AddQuizProps extends Omit<SearchAndSelectProps, "showExploreButton" | "actions"> {
    returnUrl: string;
}

/**
 * Quiz creation page
 */
export const AddQuiz = ({ returnUrl, ...snsProps }: AddQuizProps) => {
    const config = useConfig();

    const [creationTool, setCreationTool] = useState<KmsTypeComponent<any, CreationToolInjectedProps>>();

    const selectEntryForQuiz = (entryId: string) => {
        window.location.href = returnUrl.replace("{entryId}", entryId);
    };

    return (
        <SystemWidthContainer isKaf={config.application.isKAF}>
            <Box display={creationTool ? "none" : "block"}>
                <StyledTitle variant={"h2"} component={"h1"}>
                    {translate("Select media")}
                </StyledTitle>

                <StyledDescription variant={"body1"}>
                    {translate("Select existing media or upload new content to create your quiz.")}
                </StyledDescription>

                <SearchAndSelect
                    {...snsProps}
                    showExploreButton={true}
                    actions={(entry, isExplore) => (
                        <Button fullWidth={isExplore} onClick={() => selectEntryForQuiz(entry.entry.id)}>
                            {translate("Select")}
                        </Button>
                    )}
                    onCreationToolSelected={setCreationTool}
                />
            </Box>

            {creationTool && (
                <CreationToolWrapper
                    creationTool={creationTool}
                    onBack={() => setCreationTool(undefined)}
                    onSubmit={({ entry }) => selectEntryForQuiz(entry.id)}
                />
            )}
        </SystemWidthContainer>
    );
};

const SystemWidthContainer = styled(FeatureContainer)(({ theme }) => ({
    ...systemWidth({ theme }),
    marginTop: theme.spacing(4),
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
    margin: theme.spacing(0, 0, 2.5),
}));

const StyledDescription = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(4),
}));
